"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityOutlineNumberRank = void 0;
var entityOutlineNumberRank = function (item) {
  var _a;
  if (!item.outlineNumber) return 0;
  var parts = (_a = item.outlineNumber) === null || _a === void 0 ? void 0 : _a.split('.');
  var rank = parts.reduce(function (acc, val, i) {
    var multiplier = Math.pow(10, (parts.length - 1 - i) * 2);
    return acc + parseInt(val, 10) * multiplier;
  }, 0);
  return rank;
};
exports.entityOutlineNumberRank = entityOutlineNumberRank;